module.exports = __webpack_public_path__ + "static/img/chomik.627e76c0.webp";